import { PProLoading } from './site'

import $ from 'jquery';

/**
 * SequenceNumber. keeps a counter in session storage (cleared when tab is closed)
 * @param name	the name of the sequence number in storage.
 */
export class SequenceNumber {
	constructor(name) {
		this.sequence = 0;
		this.key = name;
	}
	get() {
		if (window.sessionStorage.getItem(this.key)) {
			var tmpSeqn = window.sessionStorage.getItem(this.key);
			tmpSeqn = Number.parseInt(tmpSeqn);
			if (!Number.isInteger(tmpSeqn)) tmpSeqn = 0;
			this.sequence = tmpSeqn;
		} else {
			this.sequence = 0;
		}
		return this.sequence;
	}
	inc() {
		this.sequence++;
		window.sessionStorage.setItem(this.key, this.sequence);
	}
	getNext() {
		const seq = this.get();
		this.inc();
		return seq;
	}
}

export const PProFetch = (resource, options) => {
	var csrf_token = document.querySelector('meta[name="csrf-session-token"]')?.getAttribute('content') || sessionStorage.getItem("csrf-session-token");
	sessionStorage.setItem("csrf-session-token", csrf_token);
	if (csrf_token && csrf_token !== "null") {
		if (!options) options = {};
		if (!options.headers) options.headers = {};
		options.headers['CSRF-Session-Token'] = csrf_token;
	}
	return fetch(resource, options);
}

export const PProPost = (command, extras) => {
	var csrf_token = document.querySelector('meta[name="csrf-session-token"]')?.getAttribute('content') || sessionStorage.getItem("csrf-session-token");
	document.createElement
	$(`<form class="hidden" method="POST" action="${location.protocol + '//' + location.host + location.pathname}">
		<input type="hidden" name="csrfSessionToken" value="${csrf_token}">
		<input type="hidden" name="command" value="${command}">
		${extras ? extras : ''}
	</form>`).appendTo(document.body).trigger("submit")
}

export class AjaxHelper {
	constructor() {
		this.DEFAULT_FAILURE_MESSAGE = "<p>We're sorry, but the system was unable to process your request.</p>";
		this.REDIRECT_FLAG="**REDIRECT**:";

		// All requests currently "active" or in-flight
		this.activeRequests = [];

		// Not an array of requests, but an object to keep track of one active and one pending request per type. E.g. one "orderqajax" and one "cartitemsajax"
		this.activeSync = {};
		this.pendingSync = {};
	}
	initAfterDomLoaded() {
		var pollingInterval = 10;
		if (document.querySelectorAll("#cartitemcount, #cartitemcount_mobile, .cartitemcount").length || document.querySelector("#FloatingCart") != null) {
			pollingInterval = 2;
		}
		this.syncPoller = setInterval(this.checkSync.bind(this), 1000 * pollingInterval);

		// Attempt to sync when switching pages. This is a bad practice and only works in older browsers
		window.addEventListener("beforeunload", () => {
			this.checkSync();
			return undefined;
		})
	}

	/********************** PUBLIC methods *********************/
	/**
	 * Queue an AJAX request to run, output HTML result to displayArea
	 * @param {string} commandName
	 * @param {string} displayArea
	 * @param {string[]} fieldArray
	 * @returns {Promise<Response>} a promise that resolves with the response data when the request is finished
	 */
	submit(commandName, displayArea, fieldArray) {
		PProLoading.show();
		return this.get(commandName, displayArea, fieldArray);
	}
	/**
	 * Sends newest AJAX request periodically to "sync" with server.
	 * Each type of request has a name, "syncKey"
	 * Assumes most recent request is the newest, and that older requests can be safely discarded without being run
	 * If a request is pending, replaces current pending request with new request.
	 * @param {string} syncKey
	 * @param {string} commandName
	 * @param {string} displayArea
	 * @param {string[]} fieldArray
	 * @param {Function} callback
	 */
	sync(syncKey, commandName, displayArea, fieldArray, callback) {
		// Add/replace current pending request with a newer one.
		this.pendingSync[syncKey] = {commandName, displayArea, fieldArray, callback};
	}
	/**
	 * Checks pending request queue and makes ajax requests as needed.
	 * Runs periodically, but you can force it by running directly
	 */
	checkSync() {
		for (var syncKey in this.pendingSync) {
			if (!this.pendingSync.hasOwnProperty(syncKey)) continue;
			if (this.activeSync[syncKey]) continue;
			
			var thisSyncReq = this.pendingSync[syncKey];
			if (!thisSyncReq) continue;
			this.pendingSync[syncKey] = null;
			this.activeSync[syncKey] = thisSyncReq;
			this.get(thisSyncReq.commandName, thisSyncReq.displayArea, thisSyncReq.fieldArray)
				.then(() => {
					if (typeof thisSyncReq.callback === "function") thisSyncReq.callback();
				})
				.finally(() => {
					this.activeSync[syncKey] = null;					
				});
		}
	}
	/**
	 * command=**ping** to send a simple keep alive request.
	 */
	keepAlive(url, waitMinutes){
		var waitMils = waitMinutes * 60 * 1000;
		setInterval(() => {
			fetch(url, {
				method: "GET",
				cache: "no-cache"
			});
		}, waitMils);
	}
	/**
	 * Cancel all ajax requests that haven't finished.
	 */
	abortAll() {
		this.activeRequests.forEach((req) => {
			req.abortController.abort();
		});
		// Remove "last minute ajax attempt" to save the cart, as this may complete out of order.
		window.onbeforeunload = null;
	}

	/********************** HELPER methods *********************/
	/**
	 * @param {string} requestURL
	 * @param {string} parameters
	 * @param {string} displayArea
	 * @returns {Promise<string>}
	 */
	get(requestURL, displayArea, fieldArray) {
		var parameters = this.buildAjaxParms(fieldArray);
		var abortController = new AbortController();
		var fetchPromise = PProFetch(requestURL, {
			method: "POST",
			body: parameters,
			mode: "same-origin",
			cache: "no-cache",
			headers: {
				"Content-Type": "application/x-www-form-urlencoded; charset=UTF-8"
			},
			signal: abortController.signal
		});

		fetchPromise.catch(() => {
			this.outputToElement(displayArea, this.DEFAULT_FAILURE_MESSAGE);
		});
		fetchPromise.finally(() => {
			this.activeRequests = this.activeRequests.filter((req) => {
				if (fetchPromise === req.fetchPromise) return false;
				return true;
			});
			PProLoading.hide();
		});

		var responsePromise = fetchPromise.then((response) => {
			if (!response.ok) {
				throw new Error();
			}
			return response.text();
		});
		responsePromise.then((data) => {
			if (data) this.updateHtml(data, displayArea);
		});
		responsePromise.then((data) => {
			var translateId = null;
			try { translateId = PProWeglot.translateAjaxContent(displayArea); } catch (e) {} 
			if (translateId) {
				PProWeglot.onTranslateComplete(translateId);
			}
		})

		this.activeRequests.push({
			fetchPromise,
			abortController
		});
		return responsePromise;
	}
	/** Seems like bad code, should not run Javascript generated by server, should not auto-write to a random element
	 * @param {string} elementName
	 * @param {string} content
	 */
	outputToElement(elementName, content) {
		// Check for JavaScript embedded in response and execute it by appending it to <head>
		var search = content;
		var jscode = "";
		while (search.match(/(<script\b[^>]*>\s*(<!--)?)/i)) {
			search = search.substr(search.indexOf(RegExp.$1) + RegExp.$1.length);
			if (!search.match(/((-->)?\s*<\/script>)/)) break;
			var block = search.substr(0, search.indexOf(RegExp.$1));
			search = search.substring(block.length + RegExp.$1.length);   
			jscode += block + "\n";
		}

		// Return HTML
		if (elementName) {
			try {		
				document.getElementById(elementName).innerHTML = content;
			} catch(e) {
				if (document[elementName]) document[elementName].innerHTML = content;
			}
		}
		// Run any JavaScript found in HTML
		if (jscode.length > 0) {
			// JavaScript found, run it
			var oScript = document.createElement('script');
			oScript.text = "document.write = function(s) {}; " + jscode; // document.write() is not allowed, breaks HTML
			document.getElementsByTagName("head").item(0).appendChild(oScript);
		}
	}
	/**
	 * @param {string[]} fieldArrayParm
	 */
	buildAjaxParms(fieldArrayParm) {
		var myParms = new URLSearchParams();
		if (fieldArrayParm && fieldArrayParm.length > 0) {
			var accessMethod = null;
			var myField;

			myField = document.getElementById(fieldArrayParm[0]);
			if (document.getElementById(fieldArrayParm[0])) accessMethod = "ID";
			if (document.getElementsByName(fieldArrayParm[0]).length > 0) accessMethod = "NAME";
			else accessMethod = "FORM";

			for (let i = 0; i < fieldArrayParm.length; i++) {
				if (accessMethod === "ID") {
					myField = document.getElementById(fieldArrayParm[i]);
					if (myField && myField.name == "") myField.name = fieldArrayParm[i];
				} else if (accessMethod === "NAME") {
					myField = document.getElementsByName(fieldArrayParm[i])[0];
				} else if (accessMethod === "FORM") {
					myField = document.UIservletForm.elements.namedItem(fieldArrayParm[i]);
				}

				if (myField) {
					let fieldVal = myField.value;
					if (myField.type === "checkbox") {
						fieldVal = myField.checked ? "Y" : "N";
					}
					myParms.append(myField.name, fieldVal);
				}
			}
		}
		return myParms.toString();
	}
	/**
	 * @param {string} data
	 * @param {string} outputElement
	 */
	updateHtml(data, outputElement) {
		try{
			if(data) {
				if(this.isRedirect(data)) {
					top.location.href=getRedirect(data);
				}else{
					this.outputToElement(outputElement, data);
				}
			}	
		} catch(e) {
			alert("updateHTML: " + e.name + "- " + e.message);
		}
	}
	/**
	 * @param {string} ajaxReturnMsg
	 */
	isRedirect(ajaxReturnMsg){
		var prefix = ajaxReturnMsg.substring(0, this.REDIRECT_FLAG.length);
		if(prefix == this.REDIRECT_FLAG){
			return true;
		}else{
			return false;
		}
	}
	/**
	 * @param {string} ajaxReturnMsg
	 */
	getRedirect(ajaxReturnMsg){
		return ajaxReturnMsg.substring(this.REDIRECT_FLAG.length);
	}
}
